import cx from 'classnames'
import React, { useContext } from 'react'
import Acl from '../../../lib/acl'
import IntlMessage from '../../common/intl/intl_message'
import { ContactsIcon } from '../menu_icons/contacts'
import { DashboardIcon } from '../menu_icons/dashboard'
import { DeveloperIcon } from '../menu_icons/developer'
import { EstimatesIcon } from '../menu_icons/estimates'
import { ExpensesIcon } from '../menu_icons/expenses'
import { HelpIcon } from '../menu_icons/help'
import { InvoicesIcon } from '../menu_icons/invoices'
import { LogoutIcon } from '../menu_icons/logout'
import { PinIcon } from '../menu_icons/pin'
import { PlannerIcon } from '../menu_icons/planner'
import { ProfileIcon } from '../menu_icons/profile'
import { ProjectsIcon } from '../menu_icons/projects'
import { ReportsIcon } from '../menu_icons/reports'
import { SettingsIcon } from '../menu_icons/settings'
import { TasksIcon } from '../menu_icons/tasks'
import { TimeIcon } from '../menu_icons/time'
import { UnpinIcon } from '../menu_icons/unpin'
import { ChatIcon } from '../menu_icons/chat'
import { MENU_ITEM_ICON_SIZE, SECONDARY_MENU_ITEM_ICON_SIZE } from './constants'
import { SidebarLogo } from './logo'
import { MenuItem } from './menu-item'
import { TeamChatContext } from '../../../contexts/team-chat'
import { MenuItemSecondary } from './menu-item-secondary'
import { Badge } from '../../common/badge'
import { getAppUrl } from '../../../lib/getAppUrl'

function getSettingsPage () {
  const settingPages = [
    'setting-user',
    'setting-companyprofile',
    'setting-payment',
    'setting-integration',
    'setting-subscription'
  ]

  return settingPages.find((settingsPage) => Acl.isPageAllowed(settingsPage))
}

export default function Sidebar (props) {
  const {
    navigateTo,
    isMobile,
    pageId,
    isCollapsed,
    activeTeamId,
    teams,
    pin,
    showTimer,
    showRecurringInvoice,
    isDemo,
    onClickDemoLogo,
    changeTeam,
    toggleDevMode,
    showChatButton
  } = props
  const settingsPage = getSettingsPage()
  const shared = { navigateTo, pageId }
  const pinIcon = isCollapsed ? (
    <PinIcon width={20} />
  ) : (
    <UnpinIcon width={SECONDARY_MENU_ITEM_ICON_SIZE} />
  )

  const { totalUnreadCount } = useContext(TeamChatContext)

  return (
    <div className={cx('sidebar', { 'sidebar--collapsed': isCollapsed })} data-testid='dashboard-sidebar'>
      <div className='sidebar__menu'>
        <MenuItem
          icon={<DashboardIcon width={MENU_ITEM_ICON_SIZE} />}
          title='common.sidebar.titleDashboard'
          id='dashboard'
          {...shared}
        />
        <MenuItem
          icon={<ProjectsIcon width={MENU_ITEM_ICON_SIZE} />}
          title='common.sidebar.titleProjects'
          id='project'
          {...shared}
        />
        <MenuItem
          icon={<PlannerIcon width={MENU_ITEM_ICON_SIZE} />}
          title='common.sidebar.titlePlanner'
          id='planner'
          {...shared}
        />
        <MenuItem
          icon={<PlannerIcon width={MENU_ITEM_ICON_SIZE} />}
          title='common.sidebar.titlePlanner'
          isBeta
          href='/planner-v2'
          id='planner-v2'
          {...shared}
        />
        <MenuItem
          icon={<EstimatesIcon width={MENU_ITEM_ICON_SIZE} />}
          title='common.sidebar.titleEstimates'
          id='estimate'
          {...shared}
        />
        <MenuItem
          icon={
            <Badge invisible={!showTimer} dot>
              <TimeIcon width={MENU_ITEM_ICON_SIZE} />
            </Badge>
          }
          title='common.sidebar.titleTime'
          id={isMobile ? 'time-mobile' : 'time'}
          {...shared}
        />
        <MenuItem
          icon={<TasksIcon width={MENU_ITEM_ICON_SIZE} />}
          title='common.sidebar.titleTask'
          id='task'
          {...shared}
        />
        <MenuItem
          icon={<ExpensesIcon width={MENU_ITEM_ICON_SIZE} />}
          title='common.sidebar.titleExpenses'
          id='expenses'
          {...shared}
        />
        <MenuItem
          icon={
            <Badge invisible={!showRecurringInvoice} dot>
              <InvoicesIcon width={MENU_ITEM_ICON_SIZE} />
            </Badge>
          }
          title='common.sidebar.titleInvoices'
          id='invoices'
          {...shared}
        />
        <MenuItem
          icon={<ReportsIcon width={MENU_ITEM_ICON_SIZE} />}
          title='common.sidebar.titleReports'
          id='report'
          {...shared}
        />
        <MenuItem
          icon={<ContactsIcon width={MENU_ITEM_ICON_SIZE} />}
          title='common.sidebar.titleContacts'
          href={getAppUrl('/contacts')}
          id='contact'
          {...shared}
        />
        {showChatButton && (
          <MenuItem
            icon={
              <Badge content={totalUnreadCount}>
                <ChatIcon width={MENU_ITEM_ICON_SIZE} />
              </Badge>
            }
            title='common.sidebar.titleChat'
            id='chat'
            {...shared}
          />
        )}
      </div>
      <div className='sidebar__teams'>
        {teams.map((team) => (
          <Team
            key={team.id}
            team={team}
            active={team.id === activeTeamId}
            onClick={() => changeTeam(team.id)}
          />
        ))}
      </div>
      <div className='sidebar__menu-secondary'>
        {toggleDevMode && (
          <MenuItemSecondary
            icon={<DeveloperIcon width={SECONDARY_MENU_ITEM_ICON_SIZE} />}
            title='common.sidebar.developerModeOption'
            onClick={() => toggleDevMode()}
          />
        )}
        <MenuItemSecondary
          icon={pinIcon}
          title={isCollapsed ? 'common.sidebar.pin' : 'common.sidebar.unpin'}
          onClick={() => pin(!isCollapsed)}
          data-testid='pin'
        />
        <MenuItemSecondary
          icon={<HelpIcon width={SECONDARY_MENU_ITEM_ICON_SIZE} />}
          title='common.sidebar.titleHelp'
          className='menuhelp_intercom'
        />
        <MenuItemSecondary
          icon={<ProfileIcon width={SECONDARY_MENU_ITEM_ICON_SIZE} />}
          title='common.sidebar.titleProfile'
          onClick={() => navigateTo('user-profile')}
          active={pageId === 'user-profile'}
        />
        {settingsPage && (
          <MenuItemSecondary
            icon={<SettingsIcon width={SECONDARY_MENU_ITEM_ICON_SIZE} />}
            title='common.sidebar.titleSettings'
            onClick={() => navigateTo(settingsPage)}
            active={pageId === settingsPage}
          />
        )}
        <MenuItemSecondary
          icon={<LogoutIcon width={SECONDARY_MENU_ITEM_ICON_SIZE} />}
          title='common.sidebar.titleLogout'
          onClick={() => navigateTo('logout')}
          data-testid='logout-button'
        />
      </div>

      {isDemo ? (
        <button className='sidebar__logo-button' onClick={onClickDemoLogo}>
          <SidebarLogo />
          <div className='sidebar__back-link'>
            <IntlMessage ident='common.sidebar.backToSiteTitle' />
          </div>
        </button>
      ) : (
        <a href='/'>
          <SidebarLogo />
        </a>
      )}
    </div>
  )
}

function Team (props) {
  const { team, active, ...other } = props
  const imageUrl = team.imageUrl || '/images/common/default_company.png'

  return (
    <button
      className={cx('sidebar__team', { 'sidebar__team--active': active })}
      {...other}
    >
      <div className='sidebar__team__avatar-wrapper'>
        <div className='sidebar__team__avatar'>
          <img src={imageUrl} alt={team.name} />
        </div>
      </div>
      <div className='sidebar__team__name'>{team.name}</div>
    </button>
  )
}
